module.exports = __webpack_public_path__ + "static/img/dentaire-landing.11b26e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dentaire-landing.png
// module id = 85
// module chunks = 0